// extracted by mini-css-extract-plugin
export var grayCircle = "_da-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_da-1";
export var selectedCircle = "_da-2";
export var shippingOptionImage = "_da-3";
export var shippingOptionWidgetPreview = "_da-4";